// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2y6MS","right":"styles_right__3x3Ab"};